import { RENDER_MESSAGE_TYPE_DASHBOARD } from "../../constants";
import { isEmpty } from "lodash";

const handleExistsComponentsDashboard = (tabStack, message) => {
    let updatedTabStackData = { ...tabStack };
    tabStack.components.forEach((item, i) => {
        if (
            item?.options?.tabId &&
            message?.options?.tabId &&
            item?.options?.tabId === message?.options?.tabId
        ) {
            if (message?.options?.pullDown) {
                updatedTabStackData = {
                    ...updatedTabStackData,
                    pullDownMenuComponent: message
                };
            } else {
                if (
                    !message?.message?.options?.hasOwnProperty(
                        "updateInBackground"
                    ) ||
                    !message?.message?.options?.updateInBackground
                ) {
                    updatedTabStackData = {
                        ...updatedTabStackData,
                        selectedTab: message?.options?.tabId
                    };
                }
            }
        } else if (message?.options?.pullDown) {
            updatedTabStackData = {
                ...updatedTabStackData,
                pullDownMenuComponent: message
            };
        }
    });
    const temp = {
        ...message,
        message: [{
            ...message?.options,
        }],
        options: {
            ...message?.options,
        }
    };
    updatedTabStackData = {
        ...updatedTabStackData,
        selectedTab: message?.options?.tabId,
        components: [...tabStack.components, temp]
    };

    return updatedTabStackData;
};

const handleNonExistsComponentsDashboard = (tabStack, message) => {
    let updatedTabStackData = { ...tabStack };
    if (message?.options?.pullDown) {
        updatedTabStackData = {
            ...updatedTabStackData,
            components: [],
            pullDownMenuComponent: message,
        };
    } else {
        if (
            !message?.message?.options.hasOwnProperty("updateInBackground") ||
            !message?.message?.options?.updateInBackground
        ) {
            updatedTabStackData = {
                ...updatedTabStackData,
                selectedTab: message?.message?.options?.tabId,
                components: [message],
            };
        } else {
            updatedTabStackData = {
                ...updatedTabStackData,
                components: [message],
            };
        }
    }

    return updatedTabStackData;
};

export const handleExistsNonTabDashboard = (conversationId, message, dispatch, getState) => {
    const tabStack = getState().tabStack;
    let tabStackData = tabStack?.[conversationId];

    if (
        tabStackData &&
        !_.isEmpty(tabStackData) &&
        !_.isEmpty(tabStackData.components)
    ) {
        tabStackData = handleExistsComponentsDashboard(tabStackData, message);
    } else {
        tabStackData = handleNonExistsComponentsDashboard(tabStackData, message);
    }

    dispatch({
        type: RENDER_MESSAGE_TYPE_DASHBOARD,
        data: {
            [conversationId]: tabStackData,
        },
    });
};


export const handleMessageTypeDashboard = (conversationId, message) => (dispatch, getState) => {
    const tabStack = getState().tabStack;
    if (!isEmpty(tabStack)) {
        handleExistsNonTabDashboard(conversationId, message, dispatch, getState);
    } else {
        let NonConversationalData = {};
        if (message?.options?.pullDown) {
            NonConversationalData = {
                components: [],
                pullDownMenuComponent: message,
            };
        } else {
            if (
                !message?.message?.options?.hasOwnProperty("updateInBackground") ||
                !message?.message?.options?.updateInBackground
            ) {
                NonConversationalData = {
                    selectedTab: message?.options?.tabId,
                    components: [{
                        ...message,
                        message: [{
                            ...message?.options,
                        }],
                        options: {
                            ...message?.options,
                        }
                    }],
                };
            } else {
                NonConversationalData = {
                    components: [message],
                };
            }
        }

        dispatch({
            type: RENDER_MESSAGE_TYPE_DASHBOARD,
            data: {
                [conversationId]: NonConversationalData,
            },
        });
    }
};


